import { DateTime } from 'luxon';
import type { ILinkEndpoint } from '../models/link-endpoint.model';

export default class LinkEndpointHelper {
  public static getTime(accessLinkEndpoint: ILinkEndpoint, useEstimatedTime: boolean): string | undefined {
    if (!accessLinkEndpoint) {
      return undefined;
    }

    if (useEstimatedTime) {
      return accessLinkEndpoint.estimatedTime ? accessLinkEndpoint.estimatedTime : accessLinkEndpoint.plannedTime;
    }
    return accessLinkEndpoint.plannedTime;
  }

  public static isOnTime(accessLinkEndpoint: ILinkEndpoint): boolean {
    return !accessLinkEndpoint.estimatedTime || DateTime.fromISO(accessLinkEndpoint.estimatedTime).equals(DateTime.fromISO(accessLinkEndpoint.plannedTime));
  }
}
